// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Checkbox_wrap__CyHjf","checkbox":"Checkbox_checkbox__XcfXN","label":"Checkbox_label__NRj3U","required":"Checkbox_required___CxNf"};